import { Box, Stack } from "@mui/material";
import React, { memo, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import FiltersActions from "../../../../components/FiltersActions/FiltersActions";
import useFilter from "../../../../hooks/useFilter";

import {
  AutoCompleteUncontrolled,
  Button,
  DatePickerUncontrolled,
  DateRangeSelect,
  ISelectType,
} from "@4uhub/lib4uhub";
import { IMacroFilterProps } from "./models";
import { FiltersModal } from "./FiltersModal/FiltersModal";

const translationPath = "page.4uBus.logs.serviceReceived.";

const MacroFilter: React.FC<IMacroFilterProps> = ({
  onFilterParams,
  filterParams,
}) => {
  const { filter, showCleanBtn, initialState, setFilter, cleanFilter } =
    useFilter(filterParams);

  const { t } = useTranslation();

  const filterHandler = () => {
    onFilterParams(filter);
  };

  const [resetDateRange, setResetDateRange] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const cleanHandler = () => {
    onFilterParams(initialState.current);
    cleanFilter();
    setResetDateRange((prev) => !prev);
  };

  const [enableFields, setEnableFields] = useState(true);

  const handleStartDate = (date: Date | null) => {
    setFilter({ createdStart: date });
  };
  const handleEndDate = (date: Date | null) => {
    setFilter({ createdEnd: date });
  };

  const [selectedStatus, setSelectedStatus] = useState<ISelectType | null>(
    null,
  );

  const handleSelectStatus = useCallback(
    (value: ISelectType | null) => {
      setFilter({ status: value?.id ?? "" });
      setSelectedStatus(value);
    },
    [setFilter],
  );

  const handleToggleOpenModal = useCallback(() => {
    setOpenModal((prev) => !prev);
  }, []);

  const statuses: ISelectType[] = useMemo(() => {
    return [
      {
        id: "RECEBIDO",
        name: t(translationPath + "status.received"),
        code: "D",
      },
      {
        id: "INTEGRADO",
        name: t(translationPath + "status.integrated"),
        code: "I",
      },
      {
        id: "PENDENTE",
        name: t(translationPath + "status.pending"),
        code: "I",
      },
      {
        id: "ERRO",
        name: t(translationPath + "status.error"),
        code: "E",
      },
    ];
  }, [t]);

  return (
    <Stack flexDirection="row" gap={2} alignItems="center">
      <DateRangeSelect
        setEndDate={handleEndDate}
        setStartDate={handleStartDate}
        setEnableFields={setEnableFields}
        resetToToday={resetDateRange}
      />

      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.createdStart}
          onChange={(e) => setFilter({ createdStart: e })}
          label={`${t(translationPath + "start_date")}`}
          isClearable={false}
          disable={enableFields}
        />
      </Box>

      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.createdEnd}
          onChange={(e) => setFilter({ createdEnd: e })}
          label={`${t(translationPath + "end_date")}`}
          isClearable={false}
          disable={enableFields}
        />
      </Box>

      <Box sx={{ flex: "0 0 160px" }}>
        <AutoCompleteUncontrolled
          label={t(translationPath + "status_item") || "Extension"}
          onValueSelected={handleSelectStatus}
          value={selectedStatus}
          options={statuses}
          size="small"
          fullWidth
        />
      </Box>

      <Button
        variant="contained"
        onClick={() => {
          handleToggleOpenModal();
        }}
        sx={{ whiteSpace: "nowrap" }}
      >
        {t(translationPath + "more_filters")}
      </Button>

      <FiltersActions
        onFilter={filterHandler}
        onClean={cleanHandler}
        showCleanBtn={showCleanBtn}
      />

      {openModal && (
        <FiltersModal
          filter={filter}
          setFilter={setFilter}
          open={openModal}
          onClose={handleToggleOpenModal}
        />
      )}
    </Stack>
  );
};

export default memo(MacroFilter);
